import { render } from "./ZimbabweChapter.vue?vue&type=template&id=ae4d67c4"
import script from "./ZimbabweChapter.vue?vue&type=script&lang=js"
export * from "./ZimbabweChapter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\manya\\Documents\\Development\\Production\\Vue\\bbf-africa-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__